

import Header from '../Component/Nav/Header';
import SideBar from '../Component/Nav/SideBar';

export default function layout(Component: any) {
  function Layout(props: any) {
    return (
      <div className="layout-container">
        <div className="wrapper">
          <SideBar />
          <section className="right-section">
            <div className="content-area">
              <div className="content-wrapper">
                <Header />
                <main className="main-content">
                  <Component {...props} />
                </main>
              </div>
            </div>
          </section>
        </div>
      </div>
    );
  }

  return Layout;
}
